export interface JobsMayInterface {
  (session: SessionInterface, path: "jobs"): boolean;
  (session: SessionInterface, path: "jobs"): boolean;
  (session: SessionInterface, path: "jobs", action: "show" | "delete", task: JobResultRef): boolean;
}

const JobsPermissions: PermissionType<never> = {
  jobs: {
    index: () => true,
  },
};

export default JobsPermissions;
